class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {

      const isFromQuickOrder = this.closest(".quick-order-items") !== null;
      
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, null, null, isFromQuickOrder);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

var fromQuickOrder = false; // Flag to identify quick order changes

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));

    window.addEventListener("cartEmptied", this.onCartUpdate.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  showQuickOrderForm() {
    
const CartDrawer = document.querySelector('#CartDrawer');
  
    CartDrawer.classList.add('quick-order');
    
    console.log('showQuickOrderForm');
    document.querySelector('.cart-drawer-holder.cart-drawer-holder-items').style.display = 'none';
    const quickOrderFrom = document.querySelector('.cart-drawer-holder.cart-drawer-holder-quick-delivery');

    if(quickOrderFrom) {
      console.log('quickOrderFrom found');
      quickOrderFrom.removeAttribute('style');
    }
    else{
    console.log('quickOrderFrom not found');
     document.querySelector('.cart-drawer-holder.cart-drawer-holder-delivery').removeAttribute('style');
    }
      document.dispatchEvent(new CustomEvent('delivery:open'));
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        this.submitButton = event.submitButton;

        if (event.source === "cart-items") {
          return;
        }

        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

onChange(event) {
  const isFromQuickOrder = event.target.closest('.quick-order-items') !== null;

  this.updateQuantity(
    event.target.dataset.index,
    event.target.value,
    document.activeElement.getAttribute("name"),
    event.target.dataset.quantityVariantId,
    isFromQuickOrder // Pass this flag to updateQuantity
  );
}

  onCartUpdate() {
    console.log("onCartUpdate");

    let scrollPosition = 0;
    const slider = document.querySelector(".drawer__inner slider-component .slider");

    if (slider) {
      scrollPosition = slider.scrollLeft;
      console.log("Captured slider scrollPosition before fetch:", scrollPosition);
    }

    const cartDrawer = document.querySelector("#CartDrawer");
    const cartDrawerItems = document.querySelector("cart-drawer-items");

    if (this.tagName === "CART-DRAWER-ITEMS") {
      console.log("We passed the check");
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const selectors = [".drawer__inner"];

          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);

            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);

              const updatedSlider = document.querySelector(selector)?.querySelector("slider-component .slider");
              if (updatedSlider) {
                requestAnimationFrame(() => {
                  updatedSlider.scrollLeft = scrollPosition;
                });
              }

              if (cartDrawer) {
                requestAnimationFrame(() => {
                  cartDrawer.scrollTop = cartDrawer.scrollHeight;
                });
              }

              if (cartDrawerItems) {
                requestAnimationFrame(() => {
                  cartDrawerItems.scrollTop = cartDrawerItems.scrollHeight;
                });
              }
            }
          }

if (this.submitButton && "submitType" in this.submitButton.dataset && this.submitButton.dataset.submitType === "quickOrder") {
    this.showQuickOrderForm();
}
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId, isFromQuickOrder = false) {
  console.log("update quantity triggered");
    
  if (isFromQuickOrder) {
  console.log("updateQuantity called from a quick order item");

  // Get the value of #DeliveryForm-Number
  const deliveryFormNumberElement = document.querySelector("#DeliveryForm-Number");
  this.deliveryFormNumberValue = deliveryFormNumberElement ? deliveryFormNumberElement.value : '';
    console.log('this.deliveryFormNumberValue: ', this.deliveryFormNumberValue);

} else {
  console.log("updateQuantity called from another source");
}

  this.enableLoading(line);

  const body = JSON.stringify({
    line,
    quantity,
    sections: this.getSectionsToRender().map((section) => section.section),
    sections_url: window.location.pathname,
  });

  fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.text())
    .then((state) => {
      const parsedState = JSON.parse(state);

      // Parse and replace the new HTML
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll(".cart-item");

      if (parsedState.errors) {
        quantityElement.value = quantityElement.getAttribute("value");
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      this.classList.toggle("is-empty", parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector("cart-drawer");
      const cartFooter = document.getElementById("main-cart-footer");

      if (cartFooter)
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      if (cartDrawerWrapper)
        cartDrawerWrapper.classList.toggle(
          "is-empty",
          parsedState.item_count === 0
        );

      this.getSectionsToRender().forEach((section) => {
  console.log("section: ", section);

  const elementToReplace =
    document
      .getElementById(section.id)
      .querySelector(section.selector) ||
    document.getElementById(section.id);

  // Get the raw HTML and parse it into a DOM object
  const replacementHTML = this.getSectionInnerHTML(
    parsedState.sections[section.section],
    section.selector
  );

  const parser = new DOMParser();
  const parsedHTMLDocument = parser.parseFromString(replacementHTML, "text/html");
  const replacementFragment = parsedHTMLDocument.body;

  // Check if section ID is CartDrawer and handle quick order logic
  if (section.id === "CartDrawer" && isFromQuickOrder && parsedState.item_count > 0) {
    
    console.log(".CartDrawer, showing quick delivery");
    const quickDeliveryElement = replacementFragment.querySelector(".cart-drawer-holder.cart-drawer-holder-quick-delivery");
    const drawerItemsElement = replacementFragment.querySelector(".cart-drawer-holder.cart-drawer-holder-items");

    const newDeliveryFormNumberElement = replacementFragment.querySelector("#DeliveryForm-Number");
    console.log('replacementFragment:',replacementFragment);
    console.log('this.deliveryFormNumberValue: ', this.deliveryFormNumberValue);
    if (newDeliveryFormNumberElement) {
      newDeliveryFormNumberElement.setAttribute("value", this.deliveryFormNumberValue);
    }
    
    if (drawerItemsElement) {
      console.log("drawerItemsElement found");
      drawerItemsElement.style.display = "none"; // Hide the default cart items
    }

    if (quickDeliveryElement) {
      console.log("quickDeliveryElement found");
      quickDeliveryElement.style.display = ""; // Show the quick delivery element
    }
  } else {
    console.log("not CartDrawer or not from QuickOrder or parsedState.item_count == 0");
  }

  console.log("replacementFragment: ", replacementFragment);

  // Replace the HTML content with the updated fragment
  elementToReplace.innerHTML = replacementFragment.innerHTML;
});



      const updatedValue = parsedState.items[line - 1]
        ? parsedState.items[line - 1].quantity
        : undefined;
      let message = "";
      if (
        items.length === parsedState.items.length &&
        updatedValue !== parseInt(quantityElement.value)
      ) {
        if (typeof updatedValue === "undefined") {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace(
            "[quantity]",
            updatedValue
          );
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`)
            )
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper.querySelector(".drawer__inner-empty"),
          cartDrawerWrapper.querySelector("a")
        );
      } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper,
          document.querySelector(".cart-item__name")
        );
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items",
        cartData: parsedState,
        variantId: variantId,
        isFromQuickOrder: isFromQuickOrder
      });
    })
    .catch(() => {
      this.querySelectorAll(".loading-overlay").forEach((overlay) =>
        overlay.classList.add("hidden")
      );
      const errors =
        document.getElementById("cart-errors") ||
        document.getElementById("CartDrawer-CartErrors");
      errors.textContent = window.cartStrings.error;
    })
    .finally(() => {
      this.disableLoading(line);
    });
}


  updateLiveRegions(line, message) {
    const lineItemErrors = [
      ...document.querySelectorAll(`.Line-item-error-${line}`),
      ...document.querySelectorAll(`.CartDrawer-LineItemError-${line}`)
    ];

    lineItemErrors.forEach((lineItemError) => {
      if (lineItemError) {
        const errorTextElement = lineItemError.querySelector(".cart-item__error-text");
        if (errorTextElement) {
          errorTextElement.innerHTML = message;
        }
      }
    });

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    if (cartStatus) {
      cartStatus.setAttribute("aria-hidden", false);

      setTimeout(() => {
        cartStatus.setAttribute("aria-hidden", true);
      }, 1000);
    }
  }


  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}


customElements.define("cart-items", CartItems);

class CartDelivery extends HTMLElement {
  constructor() {
    super();

    // Оригиналната ти логика за радио бутоните
    this.querySelectorAll(".radio-holder input").forEach((input) => {
      input.addEventListener("change", (event) => {
        console.log("Changed:", event.target.value);
        this.updateRadioDependentValues();
      });
    });

    // Инициализация на валидацията за всички телефонни полета
    this.setupPhoneValidation();

    document.addEventListener('delivery:open', () => {
      this.loadEcontOffices();
});

this.suggestionsBox = this.querySelector('.town-suggestions');
this.townInput = this.querySelector('.field .field__input[data-id="town"]');

this.officeInput = this.querySelector('.field .field__input[data-id="office"]');
this.officeBox = this.querySelector('.office-suggestions');

this.townInput.addEventListener('click', () => {
  const field = this.townInput.closest('.field');

  // ❗ Only show suggestions if the field has NO success/error yet


  if (field && (field.classList.contains('success') || field.classList.contains('error'))) {
    return;
  }

  const value = this.townInput.value.trim().toLowerCase();

  if (value.length === 0) {
    this.appendTownSuggestions('');
  } else {
    this.appendTownSuggestions(value);
  }
});

//hide on click out of the suggestion boxes
document.addEventListener('click', (e) => {
  const clickedInsideInput = this.townInput.contains(e.target);
  const clickedInsideSuggestions = this.suggestionsBox.contains(e.target);

  const clickedInsideOfficeInput = this.officeInput.contains(e.target);
  const clickedInsideOfficeSuggestions = this.officeBox.contains(e.target);



  // If user clicks inside the input OR suggestions → do nothing
  if (clickedInsideInput || clickedInsideSuggestions) {
  }
  else {
  this.suggestionsBox.style.display = 'none';
  }

  // If user clicks inside the input OR suggestions → do nothing
  if (clickedInsideOfficeInput || clickedInsideOfficeSuggestions) {
  }
  else {
  this.officeBox.style.display = 'none';
  }
});

if (this.townInput) {
  this.townInput.addEventListener('input', (e) => {
    const value = e.target.value.trim();
    const officeField = this.officeInput.closest('.field');

    this.officeInput.value = '';
     

    officeField.classList.remove('success');
    officeField.classList.remove('error');

    
      this.appendTownSuggestions(value);
    
  });
}

this.officeInput.addEventListener('click', () => {
  const isPicked = this.officeInput.classList.contains('picked');
  const value = isPicked ? '' : this.officeInput.value.trim().toLowerCase();

  this.appendOfficeSuggestions(value);

  // Show ONLY if at least 1 suggestion exists
  if (this.officeBox.children.length > 0) {
    this.officeBox.style.display = 'block';

    // 👉 Ensure the box is visible inside "this"
    const containerRect = this.getBoundingClientRect();
    const boxRect = this.officeBox.getBoundingClientRect();

    // How much the box overflows below the visible area of the container
    const overflow = boxRect.bottom - containerRect.bottom;

    console.log('containerRect:', containerRect);
    console.log('boxRect:', boxRect);
    console.log('overflow:', overflow);

    if (overflow > 0) {
      this.scrollBy({
        top: overflow + 10, // small padding
        behavior: 'smooth'
      });
    }
  } else {
    this.officeBox.style.display = 'none';
  }
});



this.officeInput.addEventListener('input', () => {
  // User typed → no longer a picked office
  this.officeInput.classList.remove('picked');

  const value = this.officeInput.value.trim().toLowerCase();
  this.appendOfficeSuggestions(value);
});
}

appendTownSuggestions(value) {
  console.log('appendTownSuggestions trigerred');
  const query = value.toLowerCase().trim();

  // Clear old results
  this.suggestionsBox.innerHTML = '';

  const townInput = this.querySelector('.field .field__input[data-id="town"]');
  const field = townInput ? townInput.closest('.field') : null;

  // Get all towns
  const towns = Object.keys(this.econtOffices);

  // If empty → show all
  const match = query === ''
    ? towns
    : towns.filter(town =>
        town.toLowerCase().trim().startsWith(query)
      );

  // Reset success/error on empty input
  if (query === '' && field) {
    field.classList.remove('success', 'error');
  }

  // If no matches → error
  if (match.length === 0) {
    this.townErrorActions();
    return;
  }

  // Perfect match → success
  const exactMatch =
    query !== '' &&
    match.length === 1 &&
    match[0].toLowerCase().trim() === query;

  if (exactMatch) {
    this.townSuccessActions(match[0]);
    return;
  }
  if (this.officeBox) {
   this.officeBox.style.display = 'none';
   this.officeBox.innerHTML = '';
  }

  // Non-perfect match but non-empty → error
  if (field && query !== '') {
    field.classList.remove('success');
    field.classList.add('error');
  }

  this.townErrorActions();

  // Build the list of suggestions
  match.forEach(town => {
    const div = document.createElement('div');
    div.classList.add('suggestion-item');
    div.textContent = town;
    div.dataset.town = town;

    div.addEventListener('click', () => {
      this.townSuccessActions(town);
    });

    this.suggestionsBox.appendChild(div);
  });

  this.suggestionsBox.style.display = 'block';
}

townSuccessActions(town) {
  console.log('townSuccessActions triggered');
  const townInput = this.querySelector('.field .field__input[data-id="town"]');
  const field = townInput ? townInput.closest('.field') : null;

  // Fill town input
  if (townInput && town) {
    townInput.value = town;
  }

  // Apply success class
  if (field) {
    field.classList.remove('error');
    field.classList.add('success');
  }

  // Hide town suggestions
  this.suggestionsBox.innerHTML = '';
  this.suggestionsBox.style.display = 'none';

  //
  // 👉 OFFICE LOGIC
  //

  // Enable office input
  if (this.officeInput) {
    this.officeInput.removeAttribute('disabled');
    this.officeInput.closest('.field').classList.remove('disabled');
  }

   
  if (!this.officeBox) return;

  this.officeBox.innerHTML = '';

  // Offices for this town
  const offices = this.econtOffices[town] || [];

  offices.forEach(office => {
    const div = document.createElement('div');
    div.classList.add('suggestion-item');

    let address = (office.address || '').trim();

    const city = office.city ? office.city.trim() : town.trim();

    // Remove leading city name (case-insensitive, with or without space)
    address = address.replace(new RegExp(`^${city}\\s*`, 'i'), '').trim();

    div.innerHTML = `
      <span class="office-name">${office.name}</span> –
      <span class="office-address">${address}</span>
    `;

    div.dataset.officeId = office.id;
    div.dataset.officeCode = office.code;
    div.dataset.officeName = office.name;

    div.addEventListener('click', () => {
      if (this.officeInput) this.officeInput.value = office.name;
      this.officeInput.classList.add('picked');

      //this.officeBox.innerHTML = '';
     //this.officeBox.style.display = 'none';
    });

   this.officeBox.appendChild(div);
  });

 this.officeBox.style.display = 'block';

  this.scrollTo({ top: this.scrollHeight, behavior: 'smooth' });

 this.officeBox.scrollTo({ top: 0});
}

townErrorActions() {
  console.log('townErrorActions triggered');
  const townInput = this.querySelector('.field .field__input[data-id="town"]');
  const field = townInput ? townInput.closest('.field') : null;

  if (field) {
    field.classList.remove('success');
    field.classList.add('error');
  }

  // Hide town suggestions
  this.suggestionsBox.style.display = 'none';
    console.log('should add disabled now!');

  if (this.officeInput) {
    console.log('adding disabled now!');
  this.officeInput.setAttribute('disabled', 'disabled');
  this.officeInput.closest('.field').classList.add('disabled');
}

  // 👉 Hide office suggestions too
  if (this.officeBox) {
   this.officeBox.style.display = 'none';
   this.officeBox.innerHTML = '';
  }

  
}

appendOfficeSuggestions(query) {
  const officeBox = this.querySelector('.office-suggestions');
  if (!officeBox) return;

  // Get the selected town
  const townInput = this.querySelector('.field .field__input[data-id="town"]');
  const town = townInput ? townInput.value.trim() : '';

  const offices = this.econtOffices[town] || [];

  // Clear previous list
  officeBox.innerHTML = '';

  // If empty → show ALL
  const filtered = query === ''
    ? offices
    : offices.filter(office => {
        let address = (office.address || '').trim();

        return (
          office.name.toLowerCase().includes(query) ||
          address.toLowerCase().includes(query)
        );
      });

  // If no matches → ERROR + hide
  if (filtered.length === 0) {
    this.officeErrorActions();
    return;
  }

  // 👉 EXACT MATCH (success)
  if (
    query !== '' &&
    filtered.length === 1 &&
    filtered[0].name.toLowerCase().trim() === query
  ) {
    this.officeSuccessActions(filtered[0]);
    officeBox.style.display = 'none';
    return;
  }

  // 👉 PARTIAL MATCH BUT NOT EXACT → error class (like your town logic)
  if (query !== '') {
    this.officeErrorActions();
  }

  // Build list
  filtered.forEach(office => {
    const div = document.createElement('div');
    div.classList.add('suggestion-item');

    let address = (office.address || '').trim();

    div.innerHTML = `
      <span class="office-name">${office.name}</span> –
      <span class="office-address">${address}</span>
    `;

    div.dataset.officeId = office.id;
    div.dataset.officeCode = office.code;
    div.dataset.officeName = office.name;

    div.addEventListener('click', () => {
      this.officeSuccessActions(office);
    });

    officeBox.appendChild(div);
  });

  // Show the suggestion box
  officeBox.style.display = 'block';
}

officeSuccessActions(office) {
  const officeInput = this.querySelector('.field .field__input[data-id="office"]');
  const field = officeInput ? officeInput.closest('.field') : null;
  const officeBox = this.querySelector('.office-suggestions');

  // Fill office input and mark as picked
  if (officeInput && office) {
    officeInput.value = office.name;
    officeInput.classList.add('picked');
  }

  // Apply success class on the office field, if you want that too
  if (field) {
    field.classList.remove('error');
    field.classList.add('success');
  }

  // Hide and clear office suggestions
  if (officeBox) {
    officeBox.innerHTML = '';
    officeBox.style.display = 'none';
  }
}

officeErrorActions() {
  const officeInput = this.querySelector('.field .field__input[data-id="office"]');
  const field = officeInput ? officeInput.closest('.field') : null;
  const officeBox = this.querySelector('.office-suggestions');

  if (field) {
    field.classList.remove('success');
    field.classList.add('error');
  }

  if (officeBox) {
    officeBox.innerHTML = '';
    officeBox.style.display = 'none';
  }
}

loadEcontOffices() {
  if (this.econtOfficesLoaded) return;
  if (this.econtOfficesPromise) return this.econtOfficesPromise;

  const url = 'https://data.tapishoferi.com/drivo_orders/econt_offices.json';

  this.econtOfficesPromise = fetch(url, { cache: 'force-cache' })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Failed to load Econt offices: ${response.status}`);
      }
      return response.json();
    })
    .then(offices => {

      //
      // 🔥 Fix office names:
      // If office.name equals the city name → add "Централен"
      //
      Object.keys(offices).forEach(city => {
        const cityName = city.trim().toLowerCase();

        offices[city].forEach(office => {
          if (!office.name) return;

          const nameTrimmed = office.name.trim().toLowerCase();

          // If office name is exactly the same as the city name
          if (nameTrimmed === cityName) {
            office.name = `${city} Централен`;
          }
        });
      });

      //
      // Save final data
      //
      this.econtOffices = offices;
      this.econtOfficesLoaded = true;

      console.log('offices:', this.econtOffices);

      document.dispatchEvent(
        new CustomEvent('econt:officesLoaded', { detail: { offices } })
      );

      return offices;
    })
    .catch(err => {
      console.error(err);
      this.econtOfficesLoaded = false;
    });

  return this.econtOfficesPromise;
}

  setupPhoneValidation() {
    // Намираме всички полета с data-id="phone"
    this.phoneInputs = this.querySelectorAll('[data-id="phone"]');
    if (!this.phoneInputs.length) return;

    this.phoneInputs.forEach((input) => {
      const field = input.closest(".field");
      if (!field) return;

      // Почистване и валидация при въвеждане
      input.addEventListener("input", () => {
        let v = input.value.replace(/[^0-9+]/g, "");

        // само един '+' и само в началото
        const startsWithPlus = v.startsWith("+");
        v = v.replace(/\+/g, "");
        if (startsWithPlus) v = "+" + v;

        input.value = v;
        this.applyPhoneValidationClass(input, field);

      });

      // Повторна проверка при напускане
      input.addEventListener("blur", () => {
        this.applyPhoneValidationClass(input, field);
        //let v = input.value.replace(/[^0-9+]/g, "");
         //this.checkDiscount(v);
      });
    });
  }

applyPhoneValidationClass(input, field) {
  const value = input.value.trim();

  // Ако е празно — махаме класовете
  if (value === "") {
    field.classList.remove("error", "success");
    return;
  }

  // ✅ Валидни формати:
  //  - 0xxxxxxxxx
  //  - +359xxxxxxxxx
  //  - 359xxxxxxxxx
  const isValid =
    /^0\d{9}$/.test(value) ||
    /^\+359\d{9}$/.test(value) ||
    /^359\d{9}$/.test(value);

  field.classList.remove("error", "success");
  field.classList.add(isValid ? "success" : "error");

  if (isValid) {
    // 🔄 Normalize phone number to always start with 0
    let normalized = value;

    if (/^\+359/.test(value)) {
      normalized = value.replace(/^\+359/, "0");
    } else if (/^359/.test(value)) {
      normalized = value.replace(/^359/, "0");
    }

    // Call your function with the normalized number
    this.checkDiscount(normalized);
  }
  else {
    this.resetDiscountFields();
  }
}

checkDiscount(phone) {
  if (!phone) return;

  fetch("https://data.tapishoferi.com/drivo_orders/discounts-check.php", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({ phone }),
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("Response:", data);

      const deliveryTotalField = document.querySelector(
        ".cart-drawer .cart-drawer-holder-delivery .totals__total-value"
      );
      const quickDeliveryTotalField = document.querySelector(
        ".cart-drawer .cart-drawer-holder-quick-delivery .totals__total-value"
      );

      const discountLabelHolder = document.querySelector(
        ".cart-drawer .cart-drawer-holder-delivery .discount-label"
      );
      const quickDiscountLabelHolder = document.querySelector(
        ".cart-drawer .cart-drawer-holder-quick-delivery .discount-label"
      );

      if (!deliveryTotalField) return;

      const deliveryDiscounted = deliveryTotalField.querySelector(".discounted");
      if(quickDeliveryTotalField){
      const quickDeliveryDiscounted = quickDeliveryTotalField.querySelector(".discounted");
      }

      // ✅ Main logic
      if (data.success && data.data) {
        const discountValue = parseFloat(data.data.discount) || 0;

        console.log('discountValue: ', discountValue);
        if (discountValue > 0) {
          const totalPrice = parseFloat(deliveryTotalField.dataset.total); // in cents
          const discountedPrice = totalPrice - totalPrice * (discountValue / 100);
          const formattedPrice = formatBGNandEUR(discountedPrice);

          console.log("final formatted price:", formattedPrice);

          // Update UI
          deliveryTotalField.classList.add("discounted");
          if(quickDeliveryTotalField) {
            quickDeliveryTotalField.classList.add("discounted");
          }

          if (deliveryDiscounted) deliveryDiscounted.textContent = formattedPrice;
          if (quickDeliveryTotalField) {
            quickDeliveryDiscounted.textContent = formattedPrice;
          }

          if (discountLabelHolder) {
            discountLabelHolder.querySelector(".discount-value").textContent = discountValue;
            discountLabelHolder.style.display = "block";
          }

          if (quickDiscountLabelHolder) {
            quickDiscountLabelHolder.querySelector(".discount-value").textContent = discountValue;
            quickDiscountLabelHolder.style.display = "block";
          }

          // ✅ Update JSON inside <script id="cartDataJSON">
          const cartDataEl = document.getElementById("cartDataJSON");
          if (cartDataEl) {
            try {
              const cartData = JSON.parse(cartDataEl.textContent);

              // Update total_discount (percentage)
              cartData.total_discount = discountValue;

              // Update total_price (in cents)
              cartData.total_price = Math.round(discountedPrice);

              // Serialize back to JSON
              cartDataEl.textContent = JSON.stringify(cartData, null, 2);

              console.log("Updated cartDataJSON:", {
                total_discount: cartData.total_discount,
                total_price: cartData.total_price,
              });
            } catch (err) {
              console.error("Failed to update cartDataJSON:", err);
            }
          }

        } else {
          this.resetDiscountFields();
        }
      } else {
        console.warn("Телефонът не е намерен.");
        this.resetDiscountFields();
      }
    })
    .catch((err) => {
      console.error("Грешка при заявката:", err);
    });
}

resetDiscountFields() {
  const deliveryTotalField = document.querySelector(
    ".cart-drawer .cart-drawer-holder-delivery .totals__total-value"
  );
  const quickDeliveryTotalField = document.querySelector(
    ".cart-drawer .cart-drawer-holder-quick-delivery .totals__total-value"
  );

  const discountLabelHolder = document.querySelector(
    ".cart-drawer .cart-drawer-holder-delivery .discount-label"
  );
  const quickDiscountLabelHolder = document.querySelector(
    ".cart-drawer .cart-drawer-holder-quick-delivery .discount-label"
  );

  const deliveryDiscounted = deliveryTotalField?.querySelector(".discounted");
  if(quickDeliveryTotalField){
    const quickDeliveryDiscounted = quickDeliveryTotalField?.querySelector(".discounted");
  }
  if (deliveryTotalField) deliveryTotalField.classList.remove("discounted");
  if (quickDeliveryTotalField) quickDeliveryTotalField.classList.remove("discounted");

  if (deliveryDiscounted) deliveryDiscounted.textContent = "";
  if (quickDeliveryTotalField) quickDeliveryDiscounted.textContent = "";

  if (discountLabelHolder) {
    discountLabelHolder.querySelector(".discount-value").textContent = "";
    discountLabelHolder.style.display = "none";
  }

  if (quickDiscountLabelHolder) {
    quickDiscountLabelHolder.querySelector(".discount-value").textContent = "";
    quickDiscountLabelHolder.style.display = "none";
  }
}

  updateRadioDependentValues() {
    console.log("Checking values");

    document
      .querySelectorAll(".radio-holder input:checked")
      .forEach((input) => {
        const fieldName = input.name;
        const fieldValue = input.value;

        document
          .querySelectorAll(
            '.field-block-holder[data-show-name="' + fieldName + '"]'
          )
          .forEach((depHolder) => {
            const fieldInput = depHolder.querySelector(".field__input");

            if (depHolder.dataset.showWith == fieldValue) {
              depHolder.style.display = "block";
              depHolder.classList.add('active');
              fieldInput && fieldInput.setAttribute("required", true);
            } else {
              depHolder.style.display = "none";
              depHolder.classList.remove('active');
              fieldInput && fieldInput.removeAttribute("required");

              //const fieldParent = fieldInput?.closest(".field");
              //fieldParent?.classList.remove("error", "success");
            }
          });
      });

    // Повторна проверка на видимите телефонни полета
    this.phoneInputs?.forEach((input) => {
      if (input.offsetParent !== null) {
        const field = input.closest(".field");
        this.applyPhoneValidationClass(input, field);
      }
    });
  }
}

customElements.define("cart-delivery", CartDelivery);

class DrawerInner extends HTMLElement {
  constructor() {
    super();

    const deliveryForm = this.querySelectorAll(".delivery-form");

    if (deliveryForm) {
      deliveryForm.forEach((form) => {
        form.addEventListener("submit", (event) => {
          event.preventDefault();
          this.prepareOrderData(form);
        });
      });
    }

    this.querySelectorAll(".back-to-cart").forEach((backButton) => {
      backButton.addEventListener("click", (event) => {
        this.backToCart();
      });
    });

    this.querySelector("#CartDrawer-Delivery").addEventListener(
      "click",
      (event) => {
        this.goToDelivery();
      }
    );
    if(this.querySelector("#CartDrawer-QuickDelivery")){
    this.querySelector("#CartDrawer-QuickDelivery").addEventListener(
      "click",
      (event) => {
        console.log('going to quick delivery');
        this.goToQuickDelivery();
      }
    );
  }
  }

goToDelivery() {
  const CartDrawer = document.querySelector('#CartDrawer');
  CartDrawer.classList.remove('quick-order');

  const fadeOutItem = this.querySelector(".cart-drawer-holder-items");
  const fadeInItem = this.querySelector(".cart-drawer-holder-delivery");

  fadeOut(fadeOutItem, 250);
  setTimeout(() => fadeIn(fadeInItem, 250), 251);

  // 👉 Trigger event
  document.dispatchEvent(new CustomEvent('delivery:open'));
}


  goToQuickDelivery() {
     const CartDrawer = document.querySelector('#CartDrawer');
  
    CartDrawer.classList.add('quick-order');
    
    const fadeOutItem = this.querySelector(".cart-drawer-holder-items");
    const fadeInItem = this.querySelector(".cart-drawer-holder-quick-delivery");
    
    fadeOut(fadeOutItem, 250);
    setTimeout(() => fadeIn(fadeInItem, 250), 251);
  }

  backToCart() {
    const fadeInItem = document.querySelector(".cart-drawer-holder-items");
    const fadeOutItem = document.querySelector(".cart-drawer-holder-delivery");
    const fadeOutItem2 = document.querySelector(
      ".cart-drawer-holder-quick-delivery"
    );

    fadeOut(fadeOutItem, 250);
    fadeOut(fadeOutItem2, 250);
    setTimeout(() => fadeIn(fadeInItem, 250), 251);
  }

  clearCart() {
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to clear cart");
        }
        console.log("Cart cleared successfully.");

        const event = new CustomEvent("cartEmptied", {
          detail: {
            message: "Cart was emptied successfully.",
            item_count: 0, // No items in the cart
          },
        });

        document.querySelector("cart-drawer").classList.add("order-sent");
        document.querySelector("cart-drawer").classList.add("is-empty");
        const cartCountBubble = document.querySelector('.cart-count-bubble');
    if (cartCountBubble) {
      cartCountBubble.remove();
    }
        // Dispatch the event
        window.dispatchEvent(event);
      })
      .catch((error) => {
        console.error("Error clearing cart:", error);
      });
  }

  submitForm(deliveryData) {
    const fadeInItem = document.querySelector(".cart-drawer-holder-order-sent");
    const fadeOutItem = document.querySelector(
      ".cart-drawer-holder-quick-delivery"
    );
    const fadeOutItem2 = document.querySelector(".cart-drawer-holder-delivery");

    fadeOut(fadeOutItem, 250);
    fadeOut(fadeOutItem2, 250);
    setTimeout(() => fadeIn(fadeInItem, 250), 251);

    var fd = new FormData();

    fd.append("details", deliveryData);
    fd.append("date", currentDate());

    for (let [key, value] of fd.entries()) {
      console.log(`${key}: ${value}`);
    }
    fetch("https://data.tapishoferi.com/drivo_orders/save-order.php", {
      method: "POST",
      body: fd, // Assuming `fd` is your FormData object
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            "Network response was not ok: " + response.statusText
          );
        }
        return response.json(); // Ensure the response is parsed as JSON
      })
      .then((data) => {
        if (data.success) {
          this.clearCart();
          console.log("Order submitted successfully:", data.message);

          const fadeOutItem = document.querySelector(
            ".cart-drawer-holder-order-sent .loader-holder"
          );
          const fadeInItem = document.querySelector(
            ".cart-drawer-holder-order-sent .order-sent-content"
          );

          fadeOut(fadeOutItem, 250);
          setTimeout(() => fadeIn(fadeInItem, 250), 251);
        } else {
          console.error("Error:", data.error || "Unknown error");
          alert("Failed to submit order: " + (data.error || "Unknown error"));
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
        alert("An error occurred: " + error.message);
      });
  }

  prepareOrderData(deliveryForm) {
    const cartJSON = this.querySelector("#cartDataJSON").textContent;
    const cartData = JSON.parse(cartJSON);
    console.log(cartData);

    var deliveryData = "";
    var names = "";
    var phone = "";
    var town = "";
    var econtOffice = "";
    var econtAddress = "";
    var products = "";

    const formElements = deliveryForm.querySelectorAll(
      'input[type="text"][required], input[type="radio"]:checked, textarea[required]'
    );

    var fieldsValid = 1;

    formElements.forEach((element) => {

      if (element.closest('.field')?.classList.contains('error')) {
        fieldsValid = 0;
      }
      const name = element.name;
      const value = element.value;
      deliveryData += `${name}: ${value},\n`;

      if(element.dataset.id == 'names'){
        names = value;
      }
      else if(element.dataset.id == "phone"){
        phone = value;
      }
      else if(element.dataset.id == "town"){
        town = value;
      }
      else if(element.dataset.id == "address") {
        econtAddress = 'адрес ' + value;
      }
      else if(element.dataset.id == "office") {
        econtOffice = value;
      }
    });

    var copyPasteData = names + ', ' + phone + '\n' + "Еконт " + town + " " + econtAddress + econtOffice + "\n";

    cartData.items.forEach((item) => {
      console.log(item);
      deliveryData += `${item.quantity} x ${item.product_code} - ${item.title}: ${formatPrice(
        (item.price - item.price/100*cartData.total_discount)
      )},\n`;

copyPasteData += `${item.quantity > 1 ? `${item.quantity} x ` : ""}${item.product_code} ${item.order_name}${
  item.variant_title ? ` (${item.variant_title})` : ""
} - ${formatPrice((item.price - item.price/100*cartData.total_discount))?.replace(/\s+/g, "") || formatPrice((item.price - item.price/100*cartData.total_discount))}\n`;
    });

if (document.querySelector('#noCall')?.checked) {
  copyPasteData += "\n--Не звъним, данните са потвърдени!--\n";
}

    deliveryData += `\nОбща сума: ${formatPrice(cartData.total_price)}\n\n`;

    if(cartData.total_discount > 0){
      deliveryData += `\nНамаление: ${cartData.total_discount}%\n\n`;
    }

    if(formElements.length > 1){
    deliveryData += copyPasteData;
    }
    console.log(deliveryData);
    console.log(cartData.total_price, "---", formatPrice(cartData.total_price));

  if(fieldsValid == 1){
    this.submitForm(deliveryData);
  }
  else {
    this.shakeAllErrors();
  }
  }

  shakeAllErrors() {
  const errorFields = this.querySelectorAll('.field.error');
  if (errorFields.length === 0) return;

  // Run shake every 300ms
  
    errorFields.forEach(field => {
      field.classList.remove('shake');
      void field.offsetWidth; // restart animation
      field.classList.add('shake');
    });
  

  setTimeout(() => {
    errorFields.forEach(field => field.classList.remove('shake'));
  }, 3000);
}
}

customElements.define("drawer-inner", DrawerInner);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
